import React, { useState, useRef, useEffect } from "react";
import "./FAQSection.css";

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const answerRefs = useRef([]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    if (activeIndex !== null) {
      answerRefs.current[
        activeIndex
      ].style.height = `${answerRefs.current[activeIndex].scrollHeight}px`;
    }
    answerRefs.current.forEach((ref, index) => {
      if (index !== activeIndex && ref) {
        ref.style.height = "0px";
      }
    });
  }, [activeIndex]);

  const faqs = [
    {
      question: "Who can join this course?",
      answer:
        "This course is designed for everyone — from complete beginners to professionals looking to upgrade their skills. As long as you can operate a computer, you’re good to go!",
    },
    {
      question: "Are doubt-clearing sessions available?",
      answer:
        "Yes, we conduct regular doubt-clearing sessions, usually on weekends. The schedule depends on the number of queries and student availability to ensure maximum participation.",
    },
    {
      question: "How can I claim the free bonuses?",
      answer:
        "All bonus content will be revealed within the course at the appropriate stages. Since these are exclusive to enrolled students, you'll receive full access and instructions after joining.",
    },
    {
      question: "Do I need any coding knowledge for this course?",
      answer:
        "Not at all! This course does not require any coding background. It’s built to be beginner-friendly and focuses on using AI tools effectively in digital marketing.",
    },
    {
      question: "Is support available during the course?",
      answer:
        "Yes, we offer full support through email and WhatsApp. Plus, weekend doubt sessions are available to address more complex questions. Reach out anytime at info@skilltolearn.online.",
    },
    {
      question: "What is the language of instruction?",
      answer:
        "The course is conducted in Hindi to ensure easy understanding for native speakers.",
    },
  ];
  

  return (
    <div className="main-Text">
      <div className="faq-container">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              key={index}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                {faq.question}
                <span className="faq-icon">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </div>
              <div
                className="faq-answer"
                ref={(el) => (answerRefs.current[index] = el)}
              >
                {faq.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;